import React from 'react'

export const Report = ({ header, content }) => (
  <div>
    {header}
    <div className='padded-container'>
      {content}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/report/index.js